import { WarningCircleIcon } from "@phosphor-icons/react/dist/ssr/WarningCircle";

import { useTheme } from "@up/data";

import { useCart } from "../CartContext";
import DiscountForm from "../DiscountForm";
import { DiscountLineItem } from "../DiscountLineItem";

export const DiscountSection = function DiscountSection() {
  const theme = useTheme();
  const cart = useCart();
  if (!cart.data) return null;

  const coupon = cart.data.coupon;
  const errors = cart.data.errors?.filter((e) => {
    if (typeof e.path[0] !== "string") {
      return false;
    }
    return e.path[0].match(/^coupon/);
  });
  const { couponError, isApplyingCoupon } = cart;

  return (
    <section
      className="relative checkout-section max-w-sm"
      id="discount-section"
    >
      <label
        htmlFor="coupon-code-input"
        className={`block checkout-heading ${theme.heading3Class} !text-sm font-normal opacity-70 !leading-none mb-2`}
      >
        Limit one per order
      </label>

      <DiscountForm
        applyCoupon={cart.applyCoupon}
        isApplying={isApplyingCoupon}
      />
      <div className="checkout-discount-list m-0 p-0">
        {coupon && (
          <DiscountLineItem item={coupon} removeFn={cart.removeCoupon} />
        )}

        {couponError ? (
          <div
            className="text-sm"
            data-testid="checkout-discount-code-error-messages"
          >
            <p className="flex items-center gap-2 text-red-600 pt-1">
              <WarningCircleIcon size={24} weight="fill" />
              {couponError}
            </p>
          </div>
        ) : null}

        {errors?.length ? (
          <div
            className="text-sm"
            data-testid="checkout-discount-code-error-messages"
          >
            {errors.map((error, index) => {
              return (
                <p
                  key={index}
                  className="flex items-center gap-2 text-red-600 pt-1"
                >
                  <WarningCircleIcon size={24} weight="fill" />
                  {error.message}
                </p>
              );
            })}
          </div>
        ) : null}
      </div>
    </section>
  );
};
